<template>
    <div class="preTestWrap">
        <div class="preTestListWrap preTestResult">
            <h4>당신의 직무역량진단 결과는 <span><em>평균 {{averagePoint}}점</em> 입니다.</span></h4>
            <table class="table table-bordered m-5">
                <thead>
                    <tr>
                        <th>진단점수(평균)</th>
                        <th>진단 역량</th>
                        <th>사전학습과정</th>
                    </tr>
                </thead>
                <tbody v-if="averagePoint < 3">
                    <td>평균 3점 미만</td>
                    <td>초급</td>
                    <td v-html="this.currentSlide.result.level1.body"></td>
                </tbody>
                <tbody v-else-if="averagePoint < 4">
                    <td>평균 3~4점</td>
                    <td>중급</td>
                    <td v-html="this.currentSlide.result.level2.body"></td>
                </tbody>
                <tbody v-else-if="averagePoint <= 5">
                    <td>평균 4점 이상</td>
                    <td>고급</td>
                    <td v-html="this.currentSlide.result.level3.body"></td>
                </tbody>
            </table>
            <h5>나의 진단 점수에 따라 <span>보충자료를 다운받으세요.</span></h5>
            <div class="btns clearfix">
                <a :href="this.currentSlide.result.level1.file" target="_blank" type="button" v-html="this.currentSlide.result.level1.title"></a>
                <a :href="this.currentSlide.result.level2.file" target="_blank" type="button" v-html="this.currentSlide.result.level2.title"></a>
                <a :href="this.currentSlide.result.level3.file" target="_blank" type="button" v-html="this.currentSlide.result.level3.title"></a>
            </div>
            <div class="answer_reset">
                <button @click="skip" class="resetbt main">다음</button>
            </div>
        </div>
    </div> 
</template>
<script>
export default {
    props: ['currentPage','answered','currentSlide'],
    data(){
        return{
        }
    },
    computed:{
        averagePoint(){
            let total = 0;
            let sum = 0;
            _.forEach(this.answered, function(paged) {
                _.forEach(paged, function(value) {
                    total++;
                    sum += parseInt(value);
                });
            });
            console.log('sum : ' + sum);
            console.log('total : ' + total);
            return (sum / total).toFixed(1);
        },
    },
    methods:{
        skip(){
            this.$emit('skip');
        },
    },
    mounted(){
    }
}
</script>